import { createTheme } from "@mui/material/styles";

const WebTheme = createTheme({
  palette: {
    primary: {
      main: "#799C2E",
      background:"#799C2E12",
      yellow: "#9C8F2E",
      cardBackground: "#F5F5F5",
      cardBorder: '#DBDBDB',
    },
    text: {
      main: "#182439",
    },
  },
  typography: {
    fontFamily: "Poppins",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          border: "24px",
          fontFamily: "Gilroy",
          mixBlendMode: "normal",
          borderRadius: "3px",
          fontSize: "16px",
          boxShadow: "none",
          width: "100%",
          textTransform: "none",
          ...(ownerState.variant === "stripe-btn" && {
            color: "#fff",
            background: "#6C5DD3",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "100%",
            height: "46px",
            padding: "14px",
            borderRadius: "5px",
            fontWeight: "600",
            "&:hover": {
              boxShadow: "none",
              background: "#5A4AA8",
            },
          }),
          ...(ownerState.variant === "contained" && {
            color: "#fff",
            background: "#799C2E",
            fontSize: "16px",
            height: "36px",
            borderRadius: "52.2px",
            "&:hover": {
              boxShadow: "none",
              background: "#799C2E",
            },
          }),
          ...(ownerState.variant === "outlined-blue" && {
            color: "#005596",
            fontWeight: "normal",
            background: "transparent",
            borderRadius: "3px",
            borderColor: "#005596",
            border: "2px solid",
            "&:hover": {
              background: "transparent",
            },
          }),
          ...(ownerState.variant === "outlined-blue-white" && {
            color: "#005596",
            fontWeight: "normal",
            background: "transparent",
            borderRadius: "8px",
            borderColor: "#005596",
            border: "2px solid",
            "&:hover": {
              background: "transparent",
            },
          }),
          ...(ownerState.variant === "outlined-white" && {
            color: "#FFFFFF",
            fontWeight: "normal",
            background: "transparent",
            borderRadius: "8px",
            borderColor: "#FFFFFF",
            border: "2px solid",
            fontWeight: 600,
            "&:hover": {
              background: "transparent",
            },
          }),
          ...(ownerState.variant === "white-background" && {
            color: "#6C5DD3",
            fontWeight: "normal",
            background: "transparent",
            borderRadius: "8px",
            borderColor: "transparent",
            fontWeight: 600,
            border: "2px solid",
            backgroundColor: "#FFFFFF",
            "&:hover": {
              background: "#FFFFFF",
            },
          }),
          ...(ownerState.variant === "landing-button" && {
            color: "#FFFFFF",
            fontWeight: 600,
            background: "#6C5DD3",
            borderRadius: "6px",
            fontWeight: 600,
            maxWidth: "fit-content",
            "&:hover": {
              background: "#6C5DD3",
            },
          }),
          ...(ownerState.variant === "outlined-gradient" && {
            color: "inherit",
            fontWeight: "normal",
            borderRadius: "3px",
            border: "1px solid",
            borderColor: "linear-gradient(45deg, #005596 0%, #92e6f1 100%)",
            "&:hover": {
              background: "inherit",
            },
          }),
          ...(ownerState.variant === "disabled" && {
            color: "#fff !important",
            fontWeight: "normal",
            background: "#A7A7A7",
            borderRadius: "3px",
          }),
          ...(ownerState.variant === "full-blue" && {
            background: "#005596",
            color: "#fff",
            fontWeight: "normal",
            borderRadius: "3px",
            "&:hover": {
              background: "#005596",
            },
          }),
          ...(ownerState.variant === "full-dark-blue" && {
            background: "#026be9",
            color: "#fff",
            fontWeight: "normal",
            borderRadius: "8px",
            "&:hover": {
              background: "#026be9",
            },
          }),
          ...(ownerState.variant === "outlined" && {
            borderRadius: "76.2px",
            border: "1.1px solid #799C2E",
            color: "#799C2E",
            fontSize: "16px",
            fontWeight: "500",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }),
          ...(ownerState.variant === "fullWhite" && {
            background: "#fff",
            color: "#005596",
            border: "none",
            fontWeight: "normal",
            // borderRadius: "3.5px",
            "&:hover": {
              // border: "none",
              background: "#fff",
            },
          }),
          ...(ownerState.variant === "danger" && {
            background: "#d92d20",
            color: "white",
            border: "none",
            fontWeight: "normal",
            borderRadius: "8px",
            "&:hover": {
              background: "#d92d20",
            },
          }),
          ...(ownerState.variant === "outlined-black" && {
            background: "transparent",
            color: "#222",
            border: "1px solid #222",
            fontWeight: "normal",
            borderRadius: "3.5px",
            "&:hover": {
              border: "1px solid #222",
            },
          }),
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#A7A7A7",
          "&.Mui-checked": {
            color: "#6C5DD3",
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "#005596",
          },
        },
      },
    },
  },
});

export default WebTheme;
